import { API_BASE } from "@/lib/apiClient";
import type { TenantBranding } from "@/lib/branding/types";
import { tenantSlug } from "@/lib/tenantSlug";
import { observeApiExchange, observeApiTransportError } from "@shared/serverReachability";

function brandingUrl(): string {
  const path = "/api/v1/public/branding";
  if (!API_BASE) return path;
  return `${API_BASE}${path}`;
}

/** Lädt Campingplatz-Logo und Anzeigenamen (öffentlicher Endpunkt, ohne Anmeldung). */
export async function fetchPublicBranding(): Promise<TenantBranding> {
  let res: Response;
  try {
    res = await fetch(brandingUrl(), {
      credentials: "include",
      headers: {
        Accept: "application/json",
        "X-Tenant-Slug": tenantSlug(),
      },
    });
  } catch (err) {
    observeApiTransportError(err);
    throw err;
  }
  observeApiExchange(res.status);
  if (!res.ok) {
    throw new Error(`Branding konnte nicht geladen werden (${res.status})`);
  }
  return (await res.json()) as TenantBranding;
}
